import { Module } from 'vuex'
import { LaborRecordItem, ActivePagingDate } from '@/utility/Labor'

interface State {
    exportData: LaborRecordItem[]
    activePagingDates: ActivePagingDate[]
    totalCompHoliNeeded: number
}

const store: Module<State, unknown> = {
    namespaced: true,
    state() {
        return {
            exportData: [],
            activePagingDates: [],
            totalCompHoliNeeded: 11,
        }
    },
    mutations: {
        setExportData(state, payload) {
            state.exportData = payload
        },
        setActivePagingDates(state, payload) {
            state.activePagingDates = payload
        },
        setTotalCompHoliNeeded(state, newV) {
            state.totalCompHoliNeeded = newV
        },
    },
}

export default store
